

































































































































































































































































































import Vue from 'vue'
import Student from '@/models/Students/Student'
import studentEduInfoRowsBlocks from '@/components/Students/Page/studentEduInfoRowsBlocks.vue'

export default Vue.extend({
  name: 'StudentDetailRow',
  components: {studentEduInfoRowsBlocks},
  data () {
    return {}
  },
  props: {
    scope: Object as () => {
      pagination: {
        pageSize: number
        currentPage: number
        totalItems: number
      }
    },
    rowIndex: Number,
    toggleRowDetail: Function,
    row: Object as () => Student
  },
  computed: {
    cards () {
      return this.row.getCards();
    }
  }
})
